<template>
    <div class="flex-level">
        <CompassLogo v-if="item.isSellsy" theme="light" :width="24" />
        <CompassIcon v-else-if="item.compassicon" :icon="item.compassicon" size="large" />
        <i v-else-if="item['fa']" :class="`fa ${item['fa']}`"></i>
        <SaasIcon v-else-if="item['icon']" :icon="item['icon']" width="26" height="26" />

        <span v-if="item['hasSecondIcon']" class="external-chip flex-level ml-2 external-chip__icon"
            ><i class="icon-plus white"
        /></span>
        <span class="menu--label flex-level">
            {{ item['txt'] ? item['txt'] : '' }}
            <span
                v-if="item['hasSecondIcon']"
                class="external-chip flex-level ml-2 external-chip__icon-with-text"
                ><i class="icon-plus white"
            /></span>
        </span>
    </div>
</template>

<script>
import SaasIcon from 'vcomponents/common/SaasIcon.vue';
export default {
    components: {
        SaasIcon,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';

.flex-level {
    ::v-deep .compass-logo path {
        fill: currentColor;
    }
}

.external-chip {
    background-color: $primary-50;
    border-radius: 4px;
    i {
        font-size: 8px;
        padding: 4px;
    }
    &.external-chip__icon-with-text {
        opacity: 0;
        transition: visibility 0s, opacity 0.2s linear;
    }
    &.external-chip__icon {
        position: absolute;
        top: 0px;
        right: 0px;
        opacity: 0;
        transition: visibility 0s, opacity 0.2s linear;
    }
}
</style>
